// Packages
import { useState, useEffect, React } from "react";
import { Link, useParams } from "react-router-dom";
import PropTypes from "prop-types";
// Material Ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Toolbar from "@material-ui/core/Toolbar";
import backarrow from "../../assets/images/back-arrow.png";
// Styles
import "./schoolAdmin.css";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
import editIcon from "../../assets/images/editIcon.png";
import schoolLogo from "../../assets/images/default_school.png";
// Services
import userService from "../../services/user.service";
// Utils
//assets
import selectClip from "../../assets/images/selectClip.png";
import annotateClip from "../../assets/images/annotateClip.png";
import mergeClip from "../../assets/images/mergeClip.png";
import pdfTronIMG from "../../assets/images/pdfTronIMG.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

function CreateHighlight() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(0);
  const [schoolData, setSchoolData] = useState([]);
  const [imageLogo, setImageLogo] = useState(null);
  const [schoolStatus, setSchoolstatus] = useState(false);
  const [getschoolStatus, setGetSchoolstatus] = useState(false);
  const params = useParams();
  const [submitting, setSubmitting] = useState(false);
  return (
    <div id="highlight_S_create">
      <SchoolAdminDashboard />

      <div className=" p-0">
        <div className="top-strip">
          <div className="container">
            <div className="row ">
              <div className="col-lg-8 mx-auto">
                <div class=" CHbox pb-4 bgwhite" id="clipSelect">
                  <div class="card-header bgwhite pl-4 pr-4">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-6 col-sm-6 align-self">
                        <h1 className="fs-22 semibold">Create Highlight</h1>
                      </div>
                      <div className="col-lg-6 col-md-6 col-6 col-sm-6 text-right">
                        <button className="btnProceesnext  medium">
                          <Link
                            to="/highlightmerge"
                            className="linkhoverW white"
                          >
                            Proceed Next
                          </Link>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body bgwhite">
                    <div className="row justify-even">
                      <div className="col-12 col-sm-12 col-lg-3 col-md-3">
                        <div className="CHgreybox text-center">
                          <img
                            src={selectClip}
                            alt="selectclip"
                            className="img img-responsive CHht-50"
                          />
                        </div>
                        <div className="clear10"></div>
                        <div className="text-center">
                          <p className="fs-18 regular mbMargin">
                            Select your clips
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-lg-3 col-md-3">
                        <div className="CHgreybox text-center">
                          <img
                            src={mergeClip}
                            alt="hii hello"
                            className="img img-responsive CHht-50"
                          />
                        </div>
                        <div className="clear10"></div>
                        <div className="text-center">
                          <p className="fs-18 regular mbMargin">
                            Merge your clips
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-lg-3 col-md-3">
                        <div className="CHgreybox text-center">
                          <img
                            src={annotateClip}
                            alt="hii hello"
                            className="img img-responsive CHht-50"
                          />
                        </div>
                        <div className="clear10"></div>
                        <div className="text-center">
                          <p className="fs-18 regular mbMargin">
                            Annotate, Mark, edit
                          </p>
                          <div className="clear"></div>
                          {/* <p className="fs-14 regular d-contents">Powered by:</p><span>
                                                        <img src={pdfTronIMG} alt="pdf"></img>
                                                    </span> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="clear40"></div>
            <div className="row">
              <div className="col-lg-2 mx-auto text-center">
                <Link to="/schoolhighlights" className="black linkhoverB">
                  {" "}
                  <button className="btnBackHighlight">Highlights</button>
                </Link>
              </div>
            </div>
          </div>

          <div class="clear50"></div>
        </div>
      </div>
    </div>
  );
}

export default CreateHighlight;
